import fullpage from "fullpage.js";
import countdown from "../../components/countdown";

let init1 = false;
let init2 = false;
let init3 = false;
let init4 = false;
let init5 = false;

if ($("#homepage").length > 0) {
  homepage();
}

function homepage() {
  if ($(window).width() >= 1200 && $(window).height() >= 600) {
    const HomePage = new fullpage("#homepage", {
      licenseKey: "B819A8CD-4FBE4C2C-B9C7FF7E-20E597C7",
      paddingTop: "8.8rem",
      anchors: ["01", "02", "03", "04", "05", "06"],
      navigation: true,
      navigationPosition: "left",

      onLeave: function (origin, destination, direction) {
        if (origin.index == 1 && direction == "up") {
          $("#fp-nav").removeClass("black");
        } else if (origin.index == 0) {
          $("#fp-nav").addClass("black");
          $("html")[0].lang == "pl"
            ? countdown("s11", " tys.")
            : countdown("s11", ",000");
          countdown("s12", "%");
        } else if (origin.index == 1) {
          countdown("s21", "");
          countdown("s22", "");
        } else if (origin.index == 2) {
          $("html")[0].lang == "pl"
            ? countdown("s31", " tys. +")
            : countdown("s31", ",000 +");
          countdown("s32", "");
        } else if (origin.index == 3) {
          $("html")[0].lang == "pl"
            ? countdown("s41", " mln zł")
            : countdown("s41", " M", "PLN ");
          $("html")[0].lang == "pl"
            ? countdown("s42", " mln zł")
            : countdown("s42", " M", "PLN ");
        } else if (origin.index == 4) {
          countdown("s51", " +");
          countdown("s52", "");
        }
      },
    });
  } else {
    if ($(".fullpage-wrapper").length > 0) {
      fullpage_api.destroy("all");
    }
    $(window).scroll(function () {
      if (
        document.documentElement.scrollTop >
          $(".slide-1 .numbers").offset().top - $(window).height() / 1.2 &&
        !init1
      ) {
        countdown("s11", " tys.");
        countdown("s12", "%");
        init1 = true;
      } else if (
        document.documentElement.scrollTop >
          $(".slide-2 .numbers").offset().top - $(window).height() / 1.2 &&
        !init2
      ) {
        countdown("s21", "");
        countdown("s22", "");
        init2 = true;
      } else if (
        document.documentElement.scrollTop >
          $(".slide-3 .numbers").offset().top - $(window).height() / 1.2 &&
        !init3
      ) {
        countdown("s31", " tys. +");
        countdown("s32", "");
        init3 = true;
      } else if (
        document.documentElement.scrollTop >
          $(".slide-4 .numbers").offset().top - $(window).height() / 1.2 &&
        !init4
      ) {
        countdown("s41", " mln zł");
        countdown("s42", " mln zł");
        init4 = true;
      } else if (
        document.documentElement.scrollTop >
          $(".slide-5 .numbers").offset().top - $(window).height() / 1.2 &&
        !init5
      ) {
        countdown("s51", " +");
        countdown("s52", "");
        init5 = true;
      }
    });
  }
}

export default homepage;
